<template>
<div ref="container" :class="{ 'fixed': isFixed }">
  <!-- <div class="desktop-block" v-if="quickLinkList.length > 0">
    <b-card
      style="max-width: 25rem;"
      class="regular-24 quick-links-section ml-auto"
    >
      <div class="lyon-display-medium-24">Quick Links</div>
      <b-card-text>
        <div v-for="menu in quickLinkList" :key="menu.id">
          <a class="typo-color-blue bold-14" :href="menu.path">{{ menu.name }}</a>
        </div>
      </b-card-text>
    </b-card>
  </div> -->
  <div class="accordion desktop-block" role="tablist">
    <b-card no-body class="mb-1" :style="cardStyle">
      <b-card-header header-tag="header" :class="minButtonTop ? 'p-0' : 'p-1'" role="tab">
        <b-btn block v-b-toggle.accordion-1 variant="primary" size="sm" style="border-radius: 0;" @click="toggleFixedPosition">Quick Links</b-btn>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel" class="overflow-auto">
        <b-card-body class="py-2 px-3">
          <b-card-text>
            <div v-if="showAdminTools">
              <program-admin-tool-section
                :type="eventType"
                :quick-link="eventQuickLink"
                :event-datas="eventDatas"
              />
            </div>
            <div v-if="quickLinkList.length > 0">
              <div
                v-for="(menu, index) in quickLinkList"
                :key="index"
                class="mb-1"
              >
                <a class="typo-color-blue bold-16" :href="menu.path">{{ menu.name }}</a>
              </div>
            </div>
            <div v-else-if="!showAdminTools" class="text-muted regular-12">No quick links</div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</div>
</template>

<script>
import ProgramAdminToolSection from '@/components/QuickLink/ProgramAdminToolSection.vue'

export default {
  name: 'CustomQuickLinkSection',
  components: { ProgramAdminToolSection },
  props: ['quickLinkList', 'showAdminTools', 'eventType', 'eventQuickLink', 'eventDatas'],
  data() {
    return {
      isFixed: false,
      buttonTop: null,
      buttonRight: null,
      minButtonTop: 0
    }
  },
  computed: {
    cardStyle() {
      return `max-width: 25rem; max-height: ${window.innerHeight - (this.minButtonTop + 20)}px`
    },
  },
  mounted() {
    if(this.$parent.$refs.parentQuickLinkContainer) {
      const buttonRect = this.$refs.container.getBoundingClientRect()
      this.minButtonTop = buttonRect.top + window.scrollY + 25
    }
  },
  methods: {
    toggleFixedPosition() {
      if(this.$parent.$refs.parentQuickLinkContainer) {
        this.isFixed = !this.isFixed

        if (this.isFixed) {
          const buttonRect = this.$refs.container.getBoundingClientRect()
          this.buttonTop = buttonRect.top > this.minButtonTop ? buttonRect.top : this.minButtonTop
          this.buttonRight = window.innerWidth - buttonRect.right

          this.$refs.container.style.top = `${this.buttonTop}px`
          this.$refs.container.style.right = `${this.buttonRight}px`
        } else {
          this.$refs.container.style.top = null
          this.$refs.container.style.right = null
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.desktop-block {
  display: block !important;
}
.fixed {
  position: fixed;
  z-index: 2;
}
</style>
